import React from 'react';
import { ListOrdersInProductProps } from './types';
import { useOrdersListSharedQuery } from '@entities/order/libs/hooks/use-orders-list-shared-query/use-orders-list-shared-query';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { OrderListItemInProduct } from '@entities/order/ui/order-list-item-in-product/order-list-item-in-product';
import { Wrapper } from './list-orders-in-product.styles';
import { listOrdersInProductParameters } from '../../../shared/lib/utils/list-orders-in-product-parameters/list-orders-in-product-parameters';
import { NetworkStateNew } from '@shared/ui/network-state-new/network-state-new';

export const ListOrdersInProduct: React.FC<ListOrdersInProductProps> = ({ product, onClickOrder }) => {
    const user = useCurrentUserSelector();

    const [, getOrdersResult] = useOrdersListSharedQuery(
        listOrdersInProductParameters({
            productId: product.id,
            user,
        })
    );

    const ordersData = getOrdersResult.data;
    const ordersError = getQueryError(getOrdersResult);

    return (
        <Wrapper>
            <NetworkStateNew
                isInitialized={Boolean(ordersData)}
                isLoading={getOrdersResult.isLoading || getOrdersResult.isFetching || getOrdersResult.isUninitialized}
                isError={Boolean(ordersError)}
                isFiltered={false}
                hasData={Boolean(user)}
                errorProps={{
                    title: 'Ошибка загрузки сделок',
                    description: ordersError?.message,
                }}
                emptyProps={{
                    title: 'Сделки отсутствуют',
                }}
                initialLoaderProps={{
                    style: { height: 100 },
                }}>
                {ordersData?.items.map((order) => {
                    return (
                        <OrderListItemInProduct key={order.id} order={order} onClick={() => onClickOrder(order.id)} />
                    );
                })}
            </NetworkStateNew>
        </Wrapper>
    );
};
